<template>
    <button
        :type="type"
        :class="{
            'flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-secondary bg-primary hover:bg-primary-hover focus:outline-none' : true,
            'w-full': block,
            'opacity-25': loading,
        }"
        :disabled="loading"
    >
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            loading: {
                type: Boolean,
                default: false,
            },
            block: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>
